module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carts-icon",
    on: {
      "click": _vm.goCarts
    }
  }, [_c('i'), _vm._v(" "), (_vm.cartNum > 0) ? _c('div', {
    staticClass: "fix-num"
  }, [_c('div', {
    staticClass: "cart-num"
  }, [_vm._v(_vm._s(_vm.cartNum))]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1053cf75"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/cart/index.vue
// module id = 497
// module chunks = 13 16 22 25